import { MERCH, MERCH_DISCOUNT } from "constants/links";

import { useState } from "react";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Button, Collapse, Link, Stack, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Diamond } from "components/icons";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { useUserDataContext } from "context/UserDataContext";
import { Trans, useTranslation } from "react-i18next";
import { SubscriptionType } from "types/enums";

const CouponButton = styled(Button)(() => ({
  backgroundColor: "#000000",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#222",
  },
}));

const MerchCoupon = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { colors } = useMUIThemeModeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const { subscriptionType } = useUserDataContext();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Stack
        direction={{ xs: "column", lg: "row" }}
        justifyContent={"space-between"}
        alignItems={"center"}
        spacing={{ xs: 1, lg: 0 }}>
        <Button
          variant="contained"
          color="primary"
          target="_blank"
          LinkComponent={Link}
          fullWidth={isMobile}
          size={isMobile ? "small" : "medium"}
          href={MERCH}
          endIcon={<KeyboardArrowRightIcon />}>
          {t(`dashboard.communityHub.merch.primaryCta`)}
        </Button>
        <CouponButton
          variant="contained"
          size={isMobile ? "small" : "medium"}
          onClick={() => setOpen(!open)}
          disabled={subscriptionType !== SubscriptionType.PRO}
          fullWidth={isMobile}
          startIcon={<Diamond />}>
          {t(`dashboard.communityHub.merch.coupon`)}
        </CouponButton>
      </Stack>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Typography
          fontWeight={fontWeight.regular}
          color={colors.blueGray}
          fontSize={{ xs: "1rem", md: "1.375rem" }}
          textAlign={"center"}>
          <Trans
            i18nKey="dashboard.communityHub.merch.couponText"
            components={{
              a: <Link href={MERCH_DISCOUNT} target={"_blank"} color={theme.palette.primary.main} />,
            }}
          />
        </Typography>
      </Collapse>
    </>
  );
};

export default MerchCoupon;
